/* eslint-disable */
import {Service} from 'components/Shared/server';
import {ProductReviewVotePayload} from 'models/ProductReviewVotePayload';
import {ProductReviewFeedbackPayload} from 'models/ProductReviewFeedbackPayload';
import {ProductPageReviewSummary} from 'models/ProductPageReviewSummary';
import {RedReviews} from 'models/RedReviews';


export const routePostVote = (id: string) => `/api/reviews/product/${encodeURIComponent(id)}/vote`;
export function postVote(id: string, payload: ProductReviewVotePayload): Promise<Response> {
  return Service.post<Response>({
    url: routePostVote(id),
    body: payload
  });
}

export const routePostFeedback = (id: string) => `/api/reviews/product/${encodeURIComponent(id)}/feedback`;
export function postFeedback(id: string, payload: ProductReviewFeedbackPayload): Promise<Response> {
  return Service.post<Response>({
    url: routePostFeedback(id),
    body: payload
  });
}

export const routeGetProductPageReviewSummary = (id: string) => `/api/reviews/product/${encodeURIComponent(id)}/summary`;
export function getProductPageReviewSummary(id: string): Promise<ProductPageReviewSummary> {
  return Service.get<ProductPageReviewSummary>({
    url: routeGetProductPageReviewSummary(id)
  });
}

export const routeGetProductReviews = (id: string, skipReview: string, pageSize?: number, pageNumber?: number) => `/api/reviews/product/${encodeURIComponent(id)}/reviews?skipReview=${encodeURIComponent(skipReview)}&pageSize=${pageSize}&pageNumber=${pageNumber}`;
export function getProductReviews(id: string, skipReview: string, pageSize?: number, pageNumber?: number): Promise<RedReviews> {
  return Service.get<RedReviews>({
    url: routeGetProductReviews(id, skipReview, pageSize, pageNumber)
  });
}

export const routePostUpVoteReview = (reviewId: string) => `/api/reviews/product/review/${encodeURIComponent(reviewId)}/upvote`;
export function postUpVoteReview(reviewId: string): Promise<Response> {
  return Service.post<Response>({
    url: routePostUpVoteReview(reviewId),
    body: null
  });
}
